/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type UpsertEmailTriageMutationInput = {
    clientMutationId?: string | null | undefined;
    options: GoalPatchEmailTriageOptionsInput;
    orgId: string;
};
export type GoalPatchEmailTriageOptionsInput = {
    minutesDuration?: number | null | undefined;
    nameOverride?: string | null | undefined;
    syncToGoogle?: boolean | null | undefined;
};
export type UpsertEmailTriageMutationVariables = {
    input: UpsertEmailTriageMutationInput;
};
export type UpsertEmailTriageMutationResponse = {
    readonly upsertEmailTriage: {
        readonly org: {
            readonly id: string;
            readonly userGoals: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly goalId: string;
                        readonly targetUrn: {
                            readonly id: string;
                            readonly type: UrnType | null;
                            readonly value: string | null;
                        };
                        readonly otherUrns: ReadonlyArray<{
                            readonly id: string;
                            readonly type: UrnType | null;
                            readonly value: string | null;
                        }>;
                        readonly name: string;
                        readonly valueUrn: {
                            readonly id: string;
                            readonly type: UrnType | null;
                            readonly value: string | null;
                        };
                        readonly isDeleted: boolean;
                        readonly options: {
                            readonly syncToGoogle: boolean;
                            readonly specificOptions: {
                                readonly minTimeSlot?: TimeSlot | null | undefined;
                                readonly maxTimeSlot?: TimeSlot | null | undefined;
                                readonly minimumDuration?: number | null | undefined;
                                readonly idealDuration?: number | null | undefined;
                            } | null;
                        } | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type UpsertEmailTriageMutation = {
    readonly response: UpsertEmailTriageMutationResponse;
    readonly variables: UpsertEmailTriageMutationVariables;
};



/*
mutation UpsertEmailTriageMutation(
  $input: UpsertEmailTriageMutationInput!
) {
  upsertEmailTriage(input: $input) {
    org {
      id
      userGoals(first: 1000000) {
        edges {
          node {
            id
            goalId
            targetUrn {
              id
              type
              value
            }
            otherUrns {
              id
              type
              value
            }
            name
            valueUrn {
              id
              type
              value
            }
            isDeleted
            options {
              syncToGoogle
              specificOptions {
                __typename
                ... on GoalWithinDayOptions {
                  minTimeSlot
                  maxTimeSlot
                  minimumDuration
                  idealDuration
                }
              }
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "goalId",
        "storageKey": null
    } as any, v5 = [
        (v2 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v6 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "targetUrn",
        "plural": false,
        "selections": (v5 /*: any*/),
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "otherUrns",
        "plural": true,
        "selections": (v5 /*: any*/),
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "valueUrn",
        "plural": false,
        "selections": (v5 /*: any*/),
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDeleted",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "syncToGoogle",
        "storageKey": null
    } as any, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minTimeSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxTimeSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minimumDuration",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "idealDuration",
                "storageKey": null
            }
        ],
        "type": "GoalWithinDayOptions",
        "abstractKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpsertEmailTriageMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpsertEmailTriageMutationPayload",
                    "kind": "LinkedField",
                    "name": "upsertEmailTriage",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Org",
                            "kind": "LinkedField",
                            "name": "org",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "GoalConnection",
                                    "kind": "LinkedField",
                                    "name": "userGoals",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "GoalEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Goal",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "GoalOptions",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "specificOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v12 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "userGoals(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpsertEmailTriageMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpsertEmailTriageMutationPayload",
                    "kind": "LinkedField",
                    "name": "upsertEmailTriage",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Org",
                            "kind": "LinkedField",
                            "name": "org",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "GoalConnection",
                                    "kind": "LinkedField",
                                    "name": "userGoals",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "GoalEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Goal",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "GoalOptions",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "specificOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename",
                                                                            "storageKey": null
                                                                        },
                                                                        (v12 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "userGoals(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "b8c50e58d92a1f844f9cb121e4c970cf",
            "id": null,
            "metadata": {},
            "name": "UpsertEmailTriageMutation",
            "operationKind": "mutation",
            "text": "mutation UpsertEmailTriageMutation(\n  $input: UpsertEmailTriageMutationInput!\n) {\n  upsertEmailTriage(input: $input) {\n    org {\n      id\n      userGoals(first: 1000000) {\n        edges {\n          node {\n            id\n            goalId\n            targetUrn {\n              id\n              type\n              value\n            }\n            otherUrns {\n              id\n              type\n              value\n            }\n            name\n            valueUrn {\n              id\n              type\n              value\n            }\n            isDeleted\n            options {\n              syncToGoogle\n              specificOptions {\n                __typename\n                ... on GoalWithinDayOptions {\n                  minTimeSlot\n                  maxTimeSlot\n                  minimumDuration\n                  idealDuration\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'e18e19071b7098d3ec1b569146f30d36';
export default node;
